<template>
  <div class="p-4">
    <div class="flex justify-between items-center mb-4">
      <div class="flex space-x-2">
        <button
          v-can-write="'vat_rates'"
          @click="fetchVatRatesFromOneC"
          :disabled="loadingImport"
          class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50"
        >
          {{ loadingImport ? 'Загрузка...' : 'Запросить из 1С' }}
        </button>
      </div>
    </div>

    <div class="mb-6">
      <div class="relative max-w-md">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Поиск по названию или ставке..."
          class="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors duration-200 text-sm"
        />
        <div v-if="searchQuery" class="absolute inset-y-0 right-0 pr-3 flex items-center">
          <button
            @click="clearSearch"
            class="text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="flex justify-center items-center h-40">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <table v-else class="w-full border-collapse bg-white shadow-md">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Название</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Ставка %</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Не облагается</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vatRate in vatRates" :key="vatRate.id" class="border-b hover:bg-gray-50">
          <td class="px-4 py-2 text-sm text-gray-700">{{ vatRate.name || '—' }}</td>
          <td class="px-4 py-2 text-sm text-gray-700">{{ vatRate.rate }}</td>
          <td class="px-4 py-2 text-sm text-gray-700">{{ vatRate.is_exempt ? 'Да' : 'Нет' }}</td>
        </tr>
      </tbody>
    </table>

    <Pagination
      v-if="pagination.total > 0"
      :current-page="pagination.currentPage"
      :last-page="pagination.lastPage"
      :total="pagination.total"
      :per-page="pagination.perPage"
      @change-page="changePage"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { createUrlStateManager } from '@/utils/urlStateManager';

export default {
  components: { Pagination },
  data() {
    return {
      vatRates: [],
      loading: true,
      loadingImport: false,
      searchQuery: '',
      page: 1,
      perPage: 20,
      pagination: {
        currentPage: 1,
        lastPage: 1,
        total: 0,
        perPage: 20,
      },
    };
  },
  created() {
    createUrlStateManager(this, {
      searchQuery: { debounce: 300, urlKey: 'search', default: '' },
      page: { type: 'number', default: 1, urlKey: 'page' },
    }, {
      routeName: 'VatRates',
      onUpdate: (key) => {
        if (key === 'searchQuery') {
          this.page = 1;
          this.getVatRates();
        }
      },
    });

    this.getVatRates();
  },
  methods: {
    getVatRates() {
      this.loading = true;
      axios
        .post('/api/vat-rate/getVatRates', {
          page: this.page,
          per_page: this.perPage,
          search: this.searchQuery.trim() || undefined,
        })
        .then((response) => {
          const d = response.data.data;
          this.vatRates = d.data || [];
          this.pagination = {
            currentPage: d.current_page,
            lastPage: d.last_page,
            total: d.total,
            perPage: d.per_page,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },

    changePage(page) {
      this.page = page;
      this.getVatRates();
    },

    fetchVatRatesFromOneC() {
      this.loadingImport = true;
      axios
        .post('/api/vat-rate/importFromOneC')
        .then((response) => {
          if (response.data.success) {
            this.$root.$toast?.success?.('Импорт запущен. Данные появятся после обработки.');
            setTimeout(() => this.getVatRates(), 2000);
          }
        })
        .catch((error) => {
          console.error(error);
          this.$root.$toast?.error?.('Ошибка при запросе ставок НДС из 1С');
        })
        .finally(() => {
          this.loadingImport = false;
        });
    },

    clearSearch() {
      this.searchQuery = '';
    },
  },
};
</script>
